import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 0 auto;
  padding: 1rem;

  .upper-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: 24px;

    .title {
      font-size: 1.5rem;
      line-height: 1.8125rem;
      font-weight: 700;
      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

      margin: 0;
    }

    .arrows {
      display: none;
    }
  }
  @media only screen and (min-width: 800px) {
    padding-left: 6rem !important;

    .upper-content {
      margin-bottom: 32px;

      .arrows {
        display: flex;
        align-items: center;

        gap: 24px;

        svg {
          color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
        }

        .left,
        .right {
          border: none;
          background: none;

          margin: 0;
          padding: 0;
        }
      }
    }
  }
`

export const Card = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => `rgb(${theme.component.background})`};

  padding: 24px 16px;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgb(${theme.isDark ? theme.grayscale[400] : '167, 167, 167'})`};

  box-shadow: 0px 4px 20px 0px #00000040;

  height: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;

  cursor: pointer;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .image {
    width: 100%;
    max-width: 220px;
    max-height: 123px;

    display: block;
    margin: 0 auto;
  }

  .texts {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100%;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    .info {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;

      line-height: 1.5;

      margin-bottom: 8px;

      .label {
        font-weight: 700;

        margin-right: 8px;
      }
    }

    .info.chapter {
      display: flex;
      flex-direction: column;

      gap: 4px;
    }

    .info.chapter,
    .info.lesson {
      margin-bottom: 16px;
    }
  }

  .type {
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;

    color: ${({ theme }) => `rgb(${theme.blue.base})`};

    margin-top: auto;
  }

  @media only screen and (min-width: 800px) {
    padding: 24px;

    flex-direction: row;
    align-items: center;
  }
`

export const Carousel = styled.div`
  overflow: visible !important;
`
